import qs from "query-string";
import axios from "../../fetch-api/fetch-api";
import { CategoryTreeItem, ICategoryTiers } from "../interfaces/category-api.type";

export function getCategoryAggregation(url: string, category: ICategoryTiers, query: Record<string, any>) {
  if (!url) {
  }
  return axios.get<{ categories: CategoryTreeItem[] }>(`s/get-category-aggregation-v3?${qs.stringify(query)}`, {
    params: {
      url,
      ...category,
    },
  });
}
